export default __webpack_public_path__ + "static/Rectangle 1038-9c07ad857ef698190b87e62d3e2f57a7.png";